import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const WindTurbineIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M7.02 5c0-1.657.486-4 1.085-4 .6 0 1.085 2.343 1.085 4 0 .277-.03.518-.08.726A2.31 2.31 0 0 0 8.105 5.5a2.31 2.31 0 0 0-1.004.226A3.068 3.068 0 0 1 7.02 5ZM6.082 6.777a4.12 4.12 0 0 0-.487.157c-1.657.643-3.81 1.966-3.578 2.475.233.509 2.762.012 4.419-.632a1.9 1.9 0 0 1-.5-1.277c0-.255.051-.499.146-.723ZM8.016 8.497l.09.003ZM8.016 8.497c-.557-.042-.995-.472-.995-.997 0-.552.485-1 1.085-1 .194 0 .376.047.534.13.05.025.096.054.14.086.25.184.41.466.41.784a.98.98 0 0 1-.468.823 1.138 1.138 0 0 1-.617.177M10.156 6.846c.077.205.12.425.12.654 0 .514-.21.982-.556 1.336 1.654.614 4.037 1.066 4.263.573.232-.51-1.921-1.832-3.578-2.475a4.387 4.387 0 0 0-.248-.088ZM7.512 9.424a2.344 2.344 0 0 0 1.187 0l.429 3.556c.039.324.254.608.57.754a.957.957 0 0 1 .577.86V15h-4.34v-.405c0-.365.224-.698.578-.86a.968.968 0 0 0 .57-.755l.429-3.556Z"
			/>
		</svg>
	),
)
